/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';

import { IconButton } from 'ui/Components';
import { folder } from 'ui/Icons';

import styles from './HoverableListItem.css';

/**
 * render a hoverable list item
 * @param {object} props - props passed to this component
 * @returns {React.Component} a hoverable list item
 */
const HoverableListItem = props => {
  const isFolder = props.type === 'folder';

  return (
    <li
      className={`d-flex align-items-center w-100 ${styles.wrapper} ${styles.clickArea}`}
      onClick={props.onClick}
      data-test-id="hoverableListItem-handle-select"
    >
      {isFolder && (
        <IconButton className="mr-2" alt="Folder" icon={folder} rem={1.5} noMargin />
      )}
      {!isFolder && <div className={styles.spacer} />}
      <span
        className={classnames(styles.item)}
        data-test-id={`hoverable-list-item-${props.type}-${props.name}`}
        title={props.name}
      >
        {props.name}
      </span>
    </li>
  );
};

HoverableListItem.propTypes = {
  name: propTypes.string.isRequired,
  type: propTypes.string.isRequired,
  onClick: propTypes.func
};

HoverableListItem.defaultProps = {
  onClick: null
};

export default HoverableListItem;
